export default __webpack_public_path__ + "static/media/material-spock.f4d7eee8.svg";